import {Token, TokenOfType, TokenType} from "./lexer";
import {BaseTree} from "./model";

export type PatEntry =
	| (new (...args: any[]) => any) /* tree ctor */
	| TokenType
	| "any";
export type MapTypesToInstances<T extends Readonly<Array<PatEntry>>> = {
	[K in keyof T]: T[K] extends new (...args: any[]) => infer R
		? R
		: T[K] extends TokenType
			? TokenOfType<T[K]>
			: T[K] extends "any"
				? BaseTree | Token
				: never;
};

export function patternMatch<T extends Readonly<Array<PatEntry>>>(
	arr: T,
	chain: (BaseTree | Token)[] | null
): MapTypesToInstances<T> | null {
	if (chain === null || arr.length > chain.length) return null;

	// Match starting from the end: arr.at(-1) should be chain.at(-1)
	let i = arr.length - 1;
	let j = chain.length - 1;

	while (i >= 0) {
		const pat = arr[i]!;
		const elem = chain[j]!;

		if (typeof pat === "function") {
			if (!(elem instanceof pat)) return null; // expected BaseTree, found different tree
		} else if (pat !== "any") {
			if (elem instanceof BaseTree || elem.type !== pat) return null; // failed match
		}

		i--;
		j--;
	}

	return chain.slice(j + 1, chain.length) as MapTypesToInstances<T>;
}
